import * as React from "react";
import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import ArtistProfile from "./pages/ArtistProfile";
import Artists from "./pages/Artists";
import ScreenSaver from "./pages/ScreenSaver";
import ContrastContext from "./components/ContrastContext";
import { useMediaQuery } from "@mui/material";

export const AspectRatioContext = React.createContext();

function App() {
    
    const galleryDevice = useMediaQuery('(min-width:3000px)');

    const [highContrast, setHighContrast] = useState(false);

    if (galleryDevice) {
        // Prevent two finger touch gestures
        document.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, {passive: false});
    
        window.addEventListener("contextmenu", (e) => {
            e.preventDefault();
        });
    }
    return (
        <ContrastContext.Provider value = {{highContrast, setHighContrast}}>
            <Routes>
                <Route path="/" element={<ScreenSaver />} />
                <Route path="/artists" element={<Artists />} />
                <Route path="/profile/:artist" element={<ArtistProfile />} />
            </Routes>
        </ContrastContext.Provider>

    );
}

export default App;
